import {head} from '@shared/helpers/array'
import {reduceValueKeys} from '@shared/helpers/object'

import {FetchSubscriptionResponse} from '../../apis/interfaces'

import {AmountInfo} from './interfaces'

export const getAmountInfo = (
    subscriptionViewResult: FetchSubscriptionResponse['subscriptionViewResult'],
): AmountInfo => {
    const {
        products,
        coupon: {discountsByItemId, deliveryFeeDiscountsByDeliveryGroupKey},
    } = subscriptionViewResult

    let discountAmount = 0
    const productDiscountAmountByItemId = reduceValueKeys<
        AmountInfo['productDiscountAmountByItemId'],
        FetchSubscriptionResponse['subscriptionViewResult']['coupon']['discountsByItemId']
    >(
        (acc, discounts, key) => {
            const itemDiscountAmount = discounts.reduce(
                (innerAcc, {discountAmount: innerDiscountAmount}) => innerAcc + innerDiscountAmount,
                0,
            )

            acc[key] = itemDiscountAmount
            discountAmount += itemDiscountAmount

            return acc
        },
        {},
        discountsByItemId,
    )
    discountAmount += reduceValueKeys(
        (acc, discount) => {
            return acc + discount.discountAmount
        },
        0,
        deliveryFeeDiscountsByDeliveryGroupKey,
    )

    let orderAmount = 0
    const orderAmountByItemId = products.reduce<AmountInfo['orderAmountByItemId']>((acc, {items}) => {
        const headItem = head(items)

        if (headItem) {
            const itemOrderAmount = items.reduce(
                (innerAcc, {orderAmount: innerOrderAmount}) => innerAcc + innerOrderAmount,
                0,
            )
            acc[headItem.orderSheetItemId] = itemOrderAmount
            orderAmount += itemOrderAmount
        }

        return acc
    }, {})

    return {
        productDiscountAmountByItemId,
        discountAmount,
        orderAmountByItemId,
        orderAmount,
    }
}
